<!-- 默认课程 -->
<template>
  <div class='inside-component'>
     默认课程
  </div>
</template>

<script>
export default {
  name: 'PoliticalCourse',
  props: {
  },
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  mounted () {},
  methods: {}
}

</script>
<style lang='scss' scoped>
</style>
